import { useCatalogActionsContext } from "@components/Actions/CatalogActions/CatalogActionsContext";
import { useCatalogPropsStore } from "@core-ui/stores/CatalogPropsStore/CatalogPropsStore.provider";
import ItemExport, { type ExportFormat } from "@ext/wordExport/components/ItemExport";

interface ExportMenuItemProps {
	exportFormat: ExportFormat;
}

const ExportMenuItem = ({ exportFormat }: ExportMenuItemProps) => {
	const { catalogName } = useCatalogActionsContext();
	const catalogTitle = useCatalogPropsStore((state) => state.data.title);

	return <ItemExport exportFormat={exportFormat} fileName={catalogName} title={catalogTitle} />;
};

export default ExportMenuItem;
